import { Box, Img } from '@chakra-ui/react';
import React, {
  Suspense,
  createContext,
  useEffect,
  useMemo,
  useState,
  lazy,
  useContext,
  useRef,
  useCallback,
} from 'react';
import { preloadedImages, preloadedGLBFiles } from 'utils/hooks/function';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { assetImageSrc } from 'utils/hooks/imageSrc';
import { useParams } from 'react-router-dom';
import {
  getGameDemoData,
  getGameCreatorDemoData,
  updatePreviewlogs,
  getAnimations,
} from 'utils/game/gameService';
import LoadImg from 'assets/gif/SpartanGif.gif';
import { API_SERVER } from 'config/constant';

import Medieval from 'assets/glb/MedievalArtisanNPC 2.glb';
import FuturisticMaleUser from 'assets/glb/03 FuturisticMaleUser.glb';
import FuturisticFemaleUser from 'assets/glb/FuturisticFemaleUser 3.glb';
import RealFemaleUser from 'assets/glb/RealFemaleUser.glb';
import RealMaleUser from 'assets/glb/RealMaleUser.glb';
import RealFactorySupervisor from 'assets/glb/RealFactorySupervisor.glb';
import RealFemaleManager from 'assets/glb/RealFemaleManager.glb';
import RealTeamMember from 'assets/glb/RealTeamMember.glb';
import MedievalFemaleUser from 'assets/glb/04 MedievalFemaleUser.glb';
import MedievalMaleUser from 'assets/glb/05 MedievalMaleUser.glb';
import MedievalCastleMember from 'assets/glb/06 MedievalCastleMember.glb';
import FuturisticTeamMember from 'assets/glb/07 FuturisticTeamMember.glb';
import FuturisticCarOwner from 'assets/glb/08 FuturisticCarOwner.glb';
import MedievalMerchant from 'assets/glb/09 MedievalMerchant.glb';
import FuturisticScientist from 'assets/glb/10 FuturisticScientist.glb';
import FutureThemeLab from 'assets/glb/FutureThemeLab.jpg'
import FutureThemeWorkshop from 'assets/glb/FutureThemeWorkshop.jpg'
import FutureThemeLab1 from 'assets/glb/FutureThemeLab1.jpg'
import FutureThemeWorkShop1 from 'assets/glb/FutureThemeWorkShop1.jpg'

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/reducers';
import {
  onFieldContentModified,
  updatePreviewData,
  resetDeleteAction,
} from 'store/preview/previewSlice';
import { motion } from 'framer-motion';
import NoAuth from './playcards/NoAuth';
import EntirePreview from './EntirePreview';

import CompressedRoom from 'assets/glb/Compressed_room.glb';
import medievalcastle from 'assets/glb/medievalcastle.glb';
import MedievalEmporium from 'assets/glb/MedievalEmporium.glb';
import furturisticCity from 'assets/glb/Futuristiccity.glb';
import futuristicLab from 'assets/glb/Futuristiclab.glb';
import futuristicOffice from 'assets/glb/Futuristicoffice.glb';
import Magicaloffice from 'assets/glb/Magicaloffice.glb';
import Magicalunderground from 'assets/glb/Magicalunderground.glb';
import Magicalgarden from 'assets/glb/Magicalgarden.glb';
import Realisticoffice from 'assets/glb/Realisticoffice.glb';
import Realfactory from 'assets/glb/Realfactory.glb';
import Realworkplace from 'assets/glb/Realworkplace.glb';


import MagicalFemaleEnchantress from 'assets/glb/MagicalFemaleEnchantress.glb';
import MagicalFemalePotionSage from 'assets/glb/MagicalFemalePotionSage.glb';
import MagicalFemaleUser from 'assets/glb/MagicalFemaleUser.glb';
import MagicalMaleUser from 'assets/glb/MagicalMaleUser.glb';
import MagicalMaleWizard from 'assets/glb/MagicalMaleWizard.glb';
import MobileOrientationPrompt from '../../game/components/MobileOrientationPrompt';

export const ScoreContext = createContext<any>(null);
export type ProfileType = {
  score: any[];

  completedLevels: string[];
  compQuest: any[];
  currentQuest: any;
  replayScore: any[];
  playerGrandTotal: {
    questScores: Record<string, any>;
  };

  playerGender: any;
  PlayerName: any;
};

const initialProfileObject: ProfileType = {
  score: [],

  completedLevels: ['1'],
  compQuest: [],
  currentQuest: 1,
  replayScore: [],
  playerGrandTotal: { questScores: {} },
  playerGender: '',
  PlayerName: '',
};
export interface promptType {
  name: string;
  value: any;
  DelseQ: string | number;
  quest: number;
}

let creatorDataSlice: { [key: string]: number } = {};
const GamePreview = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
const audioFiles = {

  IntroMusic: require("../../../../../assets/adiuo/intromusicone.mp3")
};
  const musicRef = React.useRef(null);

   useEffect(() => {
    if (isLoading) {
      // 🎵 Play Bill’s music when loader starts
      musicRef.current = new Audio(audioFiles.IntroMusic);
      musicRef.current.loop = true; // optional looping
      musicRef.current.volume = 0.8; // optional volume control (0–1)
      musicRef.current.play().catch((err:any) => {
        console.warn("Autoplay blocked by browser:", err);
      });
    } else {
      // ⏹️ Stop music when loader ends
      if (musicRef.current) {
        musicRef.current.pause();
        musicRef.current.currentTime = 0;
      }
    }

    // 🧹 Cleanup on unmount
    return () => {
      if (musicRef.current) {
        musicRef.current.pause();
        musicRef.current.currentTime = 0;
      }
    };
  }, [isLoading]);

  const { id } = useParams();
  const { reviewid } = useParams();
  const { previewid } = useParams();
  const previewStateData = useSelector((state: RootState) =>
    previewid && state.preview ? state.preview[previewid] : null,
  );

  const dispatch = useDispatch();

  const InitialScreenId = useRef(10);

  const [gameInfo, setGameInfo] = useState<any | null>(null);
  const [timeout, setTimer] = useState(null);

  const [profile, setProfile] = useState(initialProfileObject);
  const [currentScore, setCurrentScore] = useState(0);

  const [contentReady, setContentReady] = useState<boolean>(null);
  const [apiImageSet, setApiImageSet] = useState<any>();
  const [staticAssetImageUrls, setStaticAssetImageUrls] = useState<any>(null);
  const [apiUrlAssetImageUrls, setApiUrlAssetImageUrls] = useState<any>(null); //preloaded Api image urls
  const [componentsLoaded, setComponentsLoaded] = useState(false);
  const [loadedGLBs, setLoadedGLBs] = useState<any>(null);
  const [previewLogsDataIni, setPreviewLogsDataIni] = useState<any>(null);
  const [preLogDatasIni, setPreLogDatasIni] = useState<any>(null);
  const [initialStateUpdate, setInitialStateUpdate] = useState<boolean>(false);
  const [isAuthFailed, setIsAuthFailed] = useState<{
    status: boolean;
    authMsg: string;
    reviewStatus: boolean;
  }>({ status: false, authMsg: '', reviewStatus: false });
  const [isVisible, setIsVisible] = useState<any>(false);
  const [glbName, setGlbName] = useState<any>(null);
  const [animationOptions, setAnimationOptions] = useState<any>(null);
  const [selectedBackground, setSelectedBackground] = useState<any>(null);
  const user: any = JSON.parse(localStorage.getItem('user'));

  const [promptType, setPromptType] = useState<promptType>(null);
  const [isReviewDemo, setIsReviewDemo] = useState<boolean>(null);
  const [creatorDetail, setCreatorDetail] = useState<any>();

  const [AllowQuestMsg, setAllowQuestMsg] = useState<any>(false);
  const [FirstQuestDeleteMsg, setFirstQuestDeleteMsg] = useState<any>(null);

  // const isMobile = window.matchMedia('(max-width: 768px)').matches;

  const fetchPreviewLogsData = async () => {
    try {
      if (gameInfo?.gameId) {
        if (!reviewid && !previewid && id) {
          const data = {
            previewGameId: gameInfo?.gameId ?? null,
            playerId: gameInfo?.reviewer?.ReviewerId ?? user?.data?.id,
            playerType: gameInfo?.reviewer?.ReviewerId
              ? 'reviewer'
              : user?.data?.id
              ? 'creator'
              : null,
          };
          if (
            data?.previewGameId === null &&
            data?.playerId === null &&
            data?.playerType === null
          ) {
            console.error('User data not available.');
            return false;
          }
          const userDataString = JSON.stringify(data);
          const updatePreviewLogsResponse = await updatePreviewlogs(
            userDataString,
          );
          if (
            updatePreviewLogsResponse?.status === 'Success' &&
            isAuthFailed.status === false
          ) {
            const previweProfileData = updatePreviewLogsResponse.data
              ?.previewProfile
              ? JSON.parse(updatePreviewLogsResponse.data.previewProfile)
              : null;
            function capitalizeWords(str: any) {
              return str
                .toLowerCase()
                .replace(/(?:^|\s)\S/g, function (a: any) {
                  return a.toUpperCase();
                });
            }
            if (previweProfileData !== null) {
              if (user?.data?.role === 'Creator' && !reviewid) {
                previweProfileData.name = capitalizeWords(creatorDetail.ctName);
                previweProfileData.gender = creatorDetail.ctGender;
              } else if (reviewid && !id) {
                previweProfileData.name = 'Guest';
                previweProfileData.gender = 'Male';
              }
            }

            setPreLogDatasIni({
              previewLogId: updatePreviewLogsResponse.data?.previewLogId,
              playerId: updatePreviewLogsResponse.data?.playerId,
              playerType: updatePreviewLogsResponse.data?.playerType,
              previewGameId: updatePreviewLogsResponse.data?.previewGameId,
              nevigatedSeq: updatePreviewLogsResponse.data?.nevigatedSeq
                ? JSON.parse(updatePreviewLogsResponse.data.nevigatedSeq)
                : [],
              screenIdSeq: updatePreviewLogsResponse.data?.screenIdSeq
                ? JSON.parse(updatePreviewLogsResponse.data.screenIdSeq)
                : [],
              lastActiveBlockSeq: updatePreviewLogsResponse.data
                ?.lastActiveBlockSeq
                ? JSON.parse(updatePreviewLogsResponse.data.lastActiveBlockSeq)
                : [],
              selectedOptions: updatePreviewLogsResponse.data?.selectedOptions
                ? JSON.parse(updatePreviewLogsResponse.data.selectedOptions)
                : [],
              previewProfile: updatePreviewLogsResponse.data?.previewProfile
                ? JSON.parse(updatePreviewLogsResponse.data.previewProfile)
                : [],
              lastModifiedBlockSeq:
                updatePreviewLogsResponse.data?.lastModifiedBlockSeq,
              lastBlockModifiedDate:
                updatePreviewLogsResponse.data?.lastBlockModifiedDate,
              updatedAt: updatePreviewLogsResponse.data?.updatedAt,
              playerInputs: updatePreviewLogsResponse.data?.playerInputs
                ? JSON.parse(updatePreviewLogsResponse.data.playerInputs)
                : [],
              audioVolumeValue: updatePreviewLogsResponse.data?.audioVolumeValue
                ? typeof updatePreviewLogsResponse.data?.audioVolumeValue ===
                  'string'
                  ? JSON.parse(updatePreviewLogsResponse.data?.audioVolumeValue)
                  : updatePreviewLogsResponse.data?.audioVolumeValue
                : { bgVolume: 0.3, voVolume: 0.3 },
              previewScore: updatePreviewLogsResponse.data?.previewScore
                ? JSON.parse(updatePreviewLogsResponse.data.previewScore)
                : initialProfileObject,
              questState: updatePreviewLogsResponse.data?.questState
                ? JSON.parse(updatePreviewLogsResponse.data?.questState)
                : [],
            });
            return updatePreviewLogsResponse;
          }
        } else {
          return {
            status: 'Not Available',
          };
        }
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      return false;
    }
  };

  useEffect(() => {
    const fetchPreviewLogs = async () => {
      const response = await fetchPreviewLogsData();
      if (response?.status === 'Success') {
        setPreviewLogsDataIni(response);
        setInitialStateUpdate(true);
      } else if (response?.status === 'Not Available') {
        setPreviewLogsDataIni(response);
        setInitialStateUpdate(true);
      } else if (response?.status === 'Not Available') {
        setPreviewLogsDataIni(response);
        setInitialStateUpdate(true);
      } else {
        setContentReady(false);
      }
    };
    fetchPreviewLogs();
  }, [gameInfo]);

  useEffect(() => {
    if (!gameInfo) return;

    const init = async () => {
      try {
        const [resolvedResult, preloadedGLBs] = await Promise.all([
          preloadedImages(assetImageSrc), // preload images
          (async () => {
            const gamebackground = String(gameInfo?.assets?.gasId);
            const gamecharacter = String(
              gameInfo?.gameData?.gameNonPlayingCharacterId,
            );

            const allGLBs = [
              // Backgrounds
              {
                assetType: 'backgroundGlb',
                uniqueId: '1',
                src: CompressedRoom,
                type: 'background',
              },
              {
                assetType: 'castleGlb',
                uniqueId: '2',
                src: medievalcastle,
                type: 'background',
              },
              {
                assetType: 'emporiumGlb',
                uniqueId: '3',
                src: MedievalEmporium,
                type: 'background',
              },
              {
                assetType: 'furturisticCity',
                uniqueId: '4',
                src: furturisticCity,
                type: 'background',
              },
              {
                assetType: 'futuristicGlb',
                uniqueId: '5',
                src: futuristicLab,
                type: 'background',
              },
              {
                assetType: 'futuristicOffice',
                uniqueId: '6',
                src: futuristicOffice,
                type: 'background',
              },
              {
                assetType: 'OfficeGlb',
                uniqueId: '7',
                src: Magicaloffice,
                type: 'background',
              },
              {
                assetType: 'UndergroundGlb',
                uniqueId: '8',
                src: Magicalunderground,
                type: 'background',
              },
              {
                assetType: 'Magicalgarden',
                uniqueId: '9',
                src: Magicalgarden,
                type: 'background',
              },
              {
                assetType: 'Realfactory',
                uniqueId: '10',
                src: Realfactory,
                type: 'background',
              },
              {
                assetType: 'Realworkplace',
                uniqueId: '11',
                src: Realworkplace,
                type: 'background',
              },
              {
                assetType: 'RealOfficeGlb',
                uniqueId: '12',
                src: Realisticoffice,
                type: 'background',
              },
              {
                assetType: 'FutureThemeLab',
                uniqueId: '149',
                src: FutureThemeLab,
                type: 'background',
              },
              {
                assetType: 'FutureThemeWorkshop',
                uniqueId: '150',
                src: FutureThemeWorkshop,
                type: 'background',
              },
              {
                assetType: 'FutureThemeLab1',
                uniqueId: '151',
                src: FutureThemeLab1,
                type: 'background',
              },
              {
                assetType: 'FutureThemeWorkShop1',
                uniqueId: '152',
                src: FutureThemeWorkShop1,
                type: 'background',
              },

              // Characters
              {
                assetType: 'Lucas',
                uniqueId: '31',
                src: RealFactorySupervisor,
                type: 'character',
              },
              {
                assetType: 'Olivia',
                uniqueId: '32',
                src: RealFemaleManager,
                type: 'character',
              },
              {
                assetType: 'Ryan',
                uniqueId: '33',
                src: RealTeamMember,
                type: 'character',
              },
              {
                assetType: 'Tristan',
                uniqueId: '23',
                src: MedievalCastleMember,
                type: 'character',
              },
              {
                assetType: 'Lena',
                uniqueId: '27',
                src: FuturisticTeamMember,
                type: 'character',
              },
              {
                assetType: 'Elina',
                uniqueId: '25',
                src: FuturisticCarOwner,
                type: 'character',
              },
              {
                assetType: 'Belthor',
                uniqueId: '24',
                src: MedievalMerchant,
                type: 'character',
              },
              {
                assetType: 'Zane',
                uniqueId: '26',
                src: FuturisticScientist,
                type: 'character',
              },
              {
                assetType: 'Evelina',
                uniqueId: '22',
                src: Medieval,
                type: 'character',
              },
              {
                assetType: 'Nerina',
                uniqueId: '30',
                src: MagicalFemalePotionSage,
                type: 'character',
              },
              {
                assetType: 'Eldrin',
                uniqueId: '29',
                src: MagicalMaleWizard,
                type: 'character',
              },
              {
                assetType: 'Thalassa',
                uniqueId: '28',
                src: MagicalFemaleEnchantress,
                type: 'character',
              },

              // PCs
              {
                assetType: 'FuturisticMaleUser',
                uniqueId: '1',
                src: FuturisticMaleUser,
                theme: 'Future',
                type: 'pc',
              },
              {
                assetType: 'FuturisticFemaleUser',
                uniqueId: '2',
                src: FuturisticFemaleUser,
                theme: 'Future',
                type: 'pc',
              },
              {
                assetType: 'RealFemaleUser',
                uniqueId: '3',
                src: RealFemaleUser,
                theme: 'Real',
                type: 'pc',
              },
              {
                assetType: 'RealMaleUser',
                uniqueId: '4',
                src: RealMaleUser,
                theme: 'Real',
                type: 'pc',
              },
              {
                assetType: 'MedievalFemaleUser',
                uniqueId: '5',
                src: MedievalFemaleUser,
                theme: 'Medieval',
                type: 'pc',
              },
              {
                assetType: 'MedievalMaleUser',
                uniqueId: '6',
                src: MedievalMaleUser,
                theme: 'Medieval',
                type: 'pc',
              },
              {
                assetType: 'MagicalMaleUser',
                uniqueId: '7',
                src: MagicalMaleUser,
                theme: 'Magical',
                type: 'pc',
              },
              {
                assetType: 'MagicalFemaleUser',
                uniqueId: '8',
                src: MagicalFemaleUser,
                theme: 'Magical',
                type: 'pc',
              },
            ];

            //  derive theme
            let theme = '';
            if (['1', '2', '3'].includes(gamebackground)) theme = 'Medieval';
            else if (['4', '5', '6'].includes(gamebackground)) theme = 'Future';
            else if (['7', '8', '9'].includes(gamebackground))
              theme = 'Magical';
            else if (['10', '11', '12'].includes(gamebackground))
              theme = 'Real';

            const filteredCharacterGLBs = allGLBs.filter(
              (glb) =>
                glb.type === 'character' && glb.uniqueId === gamecharacter,
            );
            const filteredBackgroundGLBs = allGLBs.filter(
              (glb) =>
                glb.type === 'background' && glb.uniqueId === gamebackground,
            );
            const matchingPCAssets = allGLBs.filter(
              (glb) => glb.type === 'pc' && glb.theme === theme,
            );

            const themedGLBs = [
              ...filteredCharacterGLBs,
              ...filteredBackgroundGLBs,
              ...matchingPCAssets,
            ].map((glb) => ({ ...glb, theme }));

            return preloadedGLBFiles(themedGLBs);
          })(),
        ]);

        setStaticAssetImageUrls(resolvedResult);
        setLoadedGLBs((prev: any) => ({ ...prev, preloadedGLBs }));

        setComponentsLoaded(true);

        handleFullScreen();
      } catch (err) {
        console.error('Init failed:', err);
      }
    };

    init();
  }, [gameInfo]);
  
  useEffect(() => {
    id && fetchCreatorDemoData();
    id && setIsReviewDemo(false);
  }, [id]);
  useEffect(() => {
    reviewid && fetchGameData();
    reviewid && setIsReviewDemo(true);
    handleFullScreen();
  }, [reviewid]);
  useEffect(() => {
    if (previewid) {
      fetchCreatorDemoData();
      setIsReviewDemo(false);

      isLoading === false && handleDataFetch();
    }
  }, [previewid, isLoading]);

  const handleFullScreen = () => {
    const element = document.documentElement;

    if (element.requestFullscreen) {
      (element as HTMLElement).requestFullscreen(); // For most browsers; // For most browsers
    } else if ((element as any).mozRequestFullScreen) {
      (element as any).mozRequestFullScreen(); // For Firefox
    } else if ((element as any).webkitRequestFullscreen) {
      (element as any).webkitRequestFullscreen(); // For Chrome, Safari, and Opera
    } else if ((element as any).msRequestFullscreen) {
      (element as any).msRequestFullscreen(); // For Internet Explorer/Edge
    } else {
      // alert('Fullscreen API is not supported by your browser.');
    }
  };

  const fetchGameData = async () => {
    const gamedata = await getGameDemoData(reviewid);

    const backgroundthemforReview = gamedata?.result?.lmsgame?.gameBackgroundId;

    setSelectedBackground(backgroundthemforReview);

    if (!gamedata?.error && gamedata) {
      const {
        gameReviewerId,
        emailId,
        activeStatus,
        reviews,
        ReviewingCreator,
        completeStatus,
      } = gamedata?.result?.lmsgamereviewer;

      if (
        (reviewid &&
          gamedata?.result?.lmsgamereviewer &&
          activeStatus === 'Inactive') ||
        ReviewingCreator?.ctDeleteStatus === 'YES'
      ) {
        setIsAuthFailed({
          status: true,
          authMsg: 'You Are not authorized user..!',
          reviewStatus: false,
        });
      } else {
        if (gamedata?.result?.completeStatus === 'Yes') {
          setIsAuthFailed({
            status: true,
            authMsg: 'You have already completed  the review for this game..!',
            reviewStatus: true,
          });
          return;
        } else {
          setIsAuthFailed({ status: false, authMsg: '', reviewStatus: false });
        }
      }
      updateGameInfo(gamedata);
    } else {
      setIsAuthFailed({
        status: true,
        authMsg: 'Game is not available at the moment...!',
        reviewStatus: false,
      });
    }
  };
  const fetchCreatorDemoData = async () => {
    const ctId = user?.data?.id;
    if (!ctId) {
      setIsAuthFailed({
        status: true,
        authMsg: 'Your session has timed out. Please login then try again.',
        reviewStatus: false,
      });
      return;
    }
    let gameId = null;
    if (previewid && !id) {
      gameId = previewid;
    } else if (id && !previewid) {
      gameId = id;
    }
    const gamedata = await getGameCreatorDemoData(gameId, ctId);

    if (!gamedata?.error && gamedata) {
      updateCreatorGameInfo(gamedata);
      const backgroundIdselected = gamedata?.result?.gameBackgroundId;

      setSelectedBackground(backgroundIdselected);
      setCreatorDetail(gamedata?.creator);
    } else {
      if (previewStateData?.action) {
        const { name, value } = previewStateData?.action;
        if (
          name === 'questDelete' &&
          value === 1 &&
          gameInfo?.gameQuest.length === 1
        ) {
          setIsAuthFailed({
            status: true,
            authMsg: 'Msg',
            reviewStatus: false,
          });
        } else {
          setIsAuthFailed({
            status: true,
            authMsg: 'Game is not availble at the moment..!',
            reviewStatus: false,
          });
        }
      } else {
        setIsAuthFailed({
          status: true,
          authMsg: 'Game is not availble at the moment..!',
          reviewStatus: false,
        });
      }
    }
    const animationOptions = await getAnimations(gameId);
    if (!animationOptions?.error) {
      setAnimationOptions(animationOptions?.data);
      setGlbName(animationOptions?.assetImages?.gasglbname);
      setIsAuthFailed({ status: false, authMsg: '', reviewStatus: false });
    }
  };
  const updateCreatorGameInfo = async (info: any) => {
    const {
      gameview,
      image,
      lmsblocks,
      lmsquestionsoptions,
      gameQuest,
      ...gameData
    } = info?.result;

    setProfile((prev: any) => ({
      ...prev,
      PlayerName: info?.creator?.ctName,
      playerGender: info?.creator?.ctGender,
    }));
    const sortBlockSequence = (blockArray: []) => {
      const transformedArray = blockArray.reduce((result: any, obj: any) => {
        const groupKey = obj?.blockQuestNo.toString();
        const seqKey = obj?.blockPrimarySequence.toString()?.split('.')[1];
        if (!result[groupKey]) {
          result[groupKey] = {};
        }
        result[groupKey][seqKey] = obj;
        return result;
      }, {});
      return transformedArray;
    };

    setGameInfo({
      gameId: info?.result?.gameId,
      gameData: gameData,
      gameHistory: gameview,
      assets: image,
      blocks: sortBlockSequence(lmsblocks),
      gameQuest: gameQuest,
      completionQuestOptions: gameQuest,
      questOptions: lmsquestionsoptions,
      reflectionQuestions: info?.resultReflection,
      gamePlayers: info?.assets?.playerCharectorsUrl,
      bgMusic:
        gameData?.gameIntroMusicName && gameData?.gameIntroMusic
          ? gameData?.gameIntroMusicName
          : '',

      gameNonPlayerUrl:
        info?.assets?.npcUrl && API_SERVER + '/' + info?.assets?.npcUrl,
    });
    const apiImageSetArr: any = [
      { assetType: 'backgroundImage', src: image?.gasAssetImage },
      {
        assetType: 'nonplayerImage',
        src: API_SERVER + '/' + info?.assets?.npcUrl,
      },
    ];
    let playerCharectorsUrls = info?.assets?.playerCharectorsUrl.map(
      (item: any, index: number) => {
        let objValue = API_SERVER + '/' + item;
        let objKey = `playerCharacterImage_${index}`;
        apiImageSetArr.push({ assetType: objKey, src: objValue });
      },
    );
    let gameQuestBadges = await Promise.all(
      info?.assets?.badges.map(async (item: Record<string, string>) => {
        Object.entries(item).forEach(([key, value]) => {
          let objkeyValue = key.split('_')[1];
          let objKey = `Quest_${objkeyValue}`;
          let objKeyValue = API_SERVER + '/' + value;
          let badgeUrl = value.split('.');
          const shadowBadgeUrl = badgeUrl[0] + '-shadow.' + badgeUrl[1];
          apiImageSetArr.push({ assetType: objKey, src: objKeyValue });
          apiImageSetArr.push({
            assetType: objKey + '-shadow',
            src: API_SERVER + '/' + shadowBadgeUrl,
          });
        });
        setApiImageSet(apiImageSetArr);
        return true;
      }),
    );
  };

  const updateGameInfo = async (info: any) => {
    const { gameReviewerId, emailId, activeStatus, reviews, ReviewingCreator } =
      info?.result?.lmsgamereviewer;
    const {
      gameview,
      image,
      lmsblocks,
      lmsquestionsoptions,
      gameQuest,
      ...gameData
    } = info?.result?.lmsgame;
    const sortBlockSequence = (blockArray: []) => {
      const transformedArray = blockArray.reduce((result: any, obj: any) => {
        const groupKey = obj?.blockQuestNo.toString();
        const seqKey = obj?.blockPrimarySequence.toString()?.split('.')[1];
        if (!result[groupKey]) {
          result[groupKey] = {};
        }
        result[groupKey][seqKey] = obj;
        return result;
      }, {});
      return transformedArray;
    };
    setGameInfo({
      gameId: info?.result?.gameId,
      gameData: gameData,
      reviewer: {
        ReviewerId: gameReviewerId,
        ReviewerName:
          ReviewingCreator === null ? null : ReviewingCreator?.ctName,
        ReviewerEmailId: emailId,
        ReviewerGender: ReviewingCreator ? ReviewingCreator?.ctGender : null,
        ReviewerStatus: activeStatus,
        ReviewerDeleteStatus: ReviewingCreator
          ? ReviewingCreator?.ctDeleteStatus
          : null,
      },
      gameQuest: gameQuest, //used for completion screen
      completionQuestOptions: gameQuest,
      reviews: reviews,
      gameHistory: gameview,
      assets: image,
      blocks: sortBlockSequence(lmsblocks),
      questOptions: lmsquestionsoptions,
      reflectionQuestions: info?.resultReflection,
      gamePlayers: info?.assets?.playerCharectorsUrl,
      bgMusic:
        info?.assets?.bgMusicUrl && API_SERVER + '/' + info?.assets?.bgMusicUrl,
      gameNonPlayerUrl:
        info?.assets?.npcUrl && API_SERVER + '/' + info?.assets?.npcUrl,
    });

    const apiImageSetArr: any = [
      { assetType: 'backgroundImage', src: image?.gasAssetImage },
      {
        assetType: 'nonplayerImage',
        src: API_SERVER + '/' + info?.assets?.npcUrl,
      },
    ];
    let playerCharectorsUrls = info?.assets?.playerCharectorsUrl.map(
      (item: any, index: number) => {
        let objValue = API_SERVER + '/' + item;
        let objKey = `playerCharacterImage_${index}`;
        apiImageSetArr.push({ assetType: objKey, src: objValue });
      },
    );
    let gameQuestBadges = await Promise.all(
      info?.assets?.badges.map(async (item: Record<string, string>) => {
        Object.entries(item).forEach(([key, value]) => {
          let objkeyValue = key.split('_')[1];
          let objKey = `Quest_${objkeyValue}`;
          let objKeyValue = API_SERVER + '/' + value;
          apiImageSetArr.push({ assetType: objKey, src: objKeyValue });
          let badgeUrl = value.split('.');
          const shadowBadgeUrl = badgeUrl[0] + '-shadow.' + badgeUrl[1];
          apiImageSetArr.push({
            assetType: objKey + '-shadow',
            src: API_SERVER + '/' + shadowBadgeUrl,
          });
        });
        setApiImageSet(apiImageSetArr);
        return true;
      }),
    );
  };

  useEffect(() => {
    return () => clearTimeout(timeout);
  }, [timeout]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resolvedResult: any = await preloadedImages(apiImageSet);
        setApiUrlAssetImageUrls(resolvedResult);
      } catch (error) {
        console.error('Error preloading images:', error);
      }
    };

    apiImageSet && fetchData();
  }, [apiImageSet]);
  const preloadedAssets = useMemo(() => {
    return { ...apiUrlAssetImageUrls, ...staticAssetImageUrls, ...loadedGLBs };
  }, [apiUrlAssetImageUrls, staticAssetImageUrls, loadedGLBs]);

  useEffect(() => {
    if (
      gameInfo &&
      apiUrlAssetImageUrls &&
      Object.keys(apiUrlAssetImageUrls).length > 0 &&
      staticAssetImageUrls &&
      Object.keys(staticAssetImageUrls).length > 0 &&
      loadedGLBs &&
      Object.keys(loadedGLBs).length > 0 &&
      componentsLoaded === true &&
      preLogDatasIni
    ) {
      setContentReady(true);
      setIsAuthFailed({ status: false, authMsg: '', reviewStatus: false });
    } else if (
      gameInfo &&
      apiUrlAssetImageUrls &&
      Object.keys(apiUrlAssetImageUrls).length > 0 &&
      staticAssetImageUrls &&
      Object.keys(staticAssetImageUrls).length > 0 &&
      loadedGLBs &&
      Object.keys(loadedGLBs).length > 0 &&
      componentsLoaded === true &&
      !preLogDatasIni
    ) {
      setContentReady(true);
      setIsAuthFailed({ status: false, authMsg: '', reviewStatus: false });
    } else {
      setContentReady(false);
    }
  }, [
    gameInfo,
    apiUrlAssetImageUrls,
    staticAssetImageUrls,
    loadedGLBs,
    componentsLoaded,
    preLogDatasIni,
  ]);
  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const hanldeLastModifiedActivity = async () => {
    const {
      currentTab = null,
      currentSubTab = null,
      currentQuest = null,
      activeBlockSeq = null,
      CompKeyCount = null,
    } = previewStateData || {};
    if (currentTab)
      switch (currentTab) {
        case 3:
          return { screenId: 1 };
        case 4:
          return {
            screenId: 2,
            currentQuest: currentQuest || 1,
            activeBlockSeq: activeBlockSeq || 1,
          };

        case 5: // design content modified
          switch (currentSubTab) {
            case 0: //completion screen
              return { screenId: 6, CompKeyCount: CompKeyCount || 0 };

            case 1: //Leaderboard
              return { screenId: 4 };

            case 2: //Reflection
              return { screenId: 3 };

            case 3: //take away
              return { screenId: 7 };

            case 4: //welcome
              return { screenId: 1 };

            case 5: //thank you
              return { screenId: 5 };
          }
          break;

        case 6: // preference content modified
          return { screenId: 10 }; //load it from the  begining
        default:
          return { screenId: 10 };
      }
  };

  const resetModifiedField = () => {
    dispatch(
      onFieldContentModified({
        gameId: previewid,
        modifiedField: null,
        updatedValue: null,
        isModified: false,
      }),
    );
  };
  const handleDataFetch = async () => {
    if (previewid && previewStateData?.isModified === true) {
      if (previewStateData?.hasOwnProperty('modifiedField')) {
        let updatedGameInfo: any = {};
        const {
          CompKeyCount,
          activeBlockSeq,
          currentQuest,
          currentSubTab,
          currentTab,
          gameId,
          isDispatched,
          isModified,
          modifiedField,
          onFocusValue,
          updatedValue,
          gameLanguage,
        } = previewStateData;
        if (currentQuest && currentTab !== 5) {
          const queststring = currentQuest.toString();
          const compleLevel = profile?.completedLevels.includes(queststring)
            ? profile.completedLevels
            : [...profile?.completedLevels, queststring];

          if (
            previewStateData.hasOwnProperty('action') &&
            previewStateData.action !== null
          ) {
            const { name, value } = previewStateData.action;
            if (!['questDelete', 'blockDelete'].includes(name)) {
              setProfile((prev: any) => ({
                ...prev,
                currentQuest: currentQuest,
                completedLevels: compleLevel,
              }));
            }
          } else {
            setProfile((prev: any) => ({
              ...prev,
              currentQuest: currentQuest,
              completedLevels: compleLevel,
            }));
          }
        }
        /**Overview Screen */
        if (currentTab === 3) {
          //show welcome
          updatedGameInfo = {
            ...gameInfo,
            gameData: { ...gameInfo.gameData, [modifiedField]: updatedValue },
          };
          setGameInfo(updatedGameInfo);
          creatorDataSlice = await hanldeLastModifiedActivity();
        } else if (currentTab === 4) {
          if (
            previewStateData.hasOwnProperty('action') &&
            previewStateData.action !== null
          ) {
            const { name, value } = previewStateData.action;
            if (
              name === 'questDelete' &&
              value === 1 &&
              gameInfo?.gameQuest.length === 1
            ) {
              setFirstQuestDeleteMsg(
                'Current Quest has been removed, Click Okay to return GameIntro Screen .You may go back to the game creation and Create Story',
              );
              setAllowQuestMsg(true);
              creatorDataSlice = await hanldeLastModifiedActivity();

              fetchCreatorDemoData();
            } else {
              setPromptType(previewStateData.action);
              creatorDataSlice = await hanldeLastModifiedActivity();
              fetchCreatorDemoData(); // Wait for the async function to complete
            }
          } else {
            setPromptType(null);
            creatorDataSlice = await hanldeLastModifiedActivity();
            fetchCreatorDemoData(); // Wait for the async function to complete
          }
        } else if (currentTab === 5) {

        /** Design Tab */
          /**Completion Screen */
          if (currentSubTab === 0) {
            const TextFieldsArray = [
              'gameAwardBadgeScore',
              'gameDistinctionScore',
              'gameMinScore',
              'gameIsSetCongratsScoreWiseMessage',
              'gameIsSetCongratsSingleMessage',
              'gameIsSetBadge',
              'gameIsSetDistinctionScore',
              'gameIsSetMinPassScore',
              'gameaboveMinimumScoreCongratsMessage',
              'gameMinimumScoreCongratsMessage',
              'gameAboveDistinctionScoreCongratsMessage',
            ];

            const updatedGameQuest = gameInfo.gameQuest.map((item: any) => {
              if (item?.gameQuestNo === parseInt(CompKeyCount) + 1) {
                if (TextFieldsArray.includes(modifiedField)) {
                  try {
                    setIsLoading(true);
                    fetchCreatorDemoData(); // Fetch data
                    // Update the state here with the new value after the fetch is done
                    updatedGameInfo = {
                      ...gameInfo,
                      gameQuest: gameInfo.gameQuest.map((questItem: any) =>
                        questItem?.gameQuestNo === parseInt(CompKeyCount) + 1
                          ? { ...questItem, [modifiedField]: updatedValue }
                          : questItem,
                      ),
                    };
                    setIsLoading(false); // Stop loading
                  } catch (error) {
                    console.error('Error fetching data:', error);
                    setIsLoading(false); // Stop loading in case of error
                  }
                  // }, 1500);
                } else if (modifiedField === 'gameBadge') {
                  return {
                    ...item,
                    [modifiedField]: updatedValue?.gasId,
                    gameBadgeName:
                      updatedValue?.gasAssetName !== undefined
                        ? updatedValue?.gasAssetName
                        : '',
                  };
                }
              }

              return item;
            });

            const updatedGameCompletionQuest =
              gameInfo.completionQuestOptions.map((item: any) => {
                if (item.questNo === parseInt(CompKeyCount) + 1) {
                  if (!TextFieldsArray.includes(modifiedField)) {
                    if (modifiedField === 'gameBadge') {
                      return {
                        ...item,
                        [modifiedField]: updatedValue?.gasId,
                        gameBadgeName:
                          updatedValue?.gasAssetName !== undefined
                            ? updatedValue?.gasAssetName
                            : '',
                      };
                    }
                    return { ...item, [modifiedField]: updatedValue }; // Update the value property
                  }
                  return { ...item, [modifiedField]: parseInt(updatedValue) }; // Update the value property
                }
                return item; // Return the unchanged item if the condition doesn't match
              });

            updatedGameInfo = {
              ...gameInfo,
              gameQuest: [...updatedGameQuest],
              completionQuestOptions: [...updatedGameCompletionQuest],
            };

            if (
              CompKeyCount === 0 &&
              updatedGameInfo.gameData.gameQuestNo === CompKeyCount + 1
            ) {
              if (TextFieldsArray.includes(modifiedField)) {
                updatedGameInfo = {
                  ...updatedGameInfo,
                  gameData: {
                    ...gameInfo.gameData,
                    [modifiedField]: updatedValue,
                  }, // Update the value property
                };
              } else {
                updatedGameInfo = {
                  ...updatedGameInfo,
                  gameData:
                    modifiedField === 'gameBadge'
                      ? {
                          ...gameInfo.gameData,
                          [modifiedField]: updatedValue?.gasId,
                          gameBadgeName:
                            updatedValue?.gasAssetName !== undefined
                              ? updatedValue?.gasAssetName
                              : '',
                        }
                      : {
                          ...gameInfo.gameData,
                          [modifiedField]: parseInt(updatedValue),
                        }, // Update the value property
                };
              }
            }
            const currentQuestNo = parseInt(CompKeyCount) + 1;

            setProfile((prev: any) => ({
              ...prev,
              currentQuest: currentQuestNo,
            }));
            if (modifiedField === 'gameBadge') {
              const updateSrc = (src: any, isShadow = false) => {
                if (isShadow) {
                  const parts = src !== undefined ? src.split('.') : '';
                  if (parts !== '') {
                    parts[parts.length - 2] += '-shadow';
                    return parts.join('.');
                  } else {
                    return '';
                  }
                }
                return src !== undefined ? src : '';
              };

              const updatedApiImageSet = apiImageSet.map((item: any) => {
                if (item.assetType === `Quest_${currentQuestNo}`) {
                  return {
                    ...item,
                    src: updateSrc(updatedValue?.gasAssetImage),
                  };
                } else if (
                  item.assetType === `Quest_${currentQuestNo}-shadow`
                ) {
                  return {
                    ...item,
                    src: updateSrc(updatedValue?.gasAssetImage, true),
                  };
                } else {
                  return item;
                }
              });
              setApiImageSet(updatedApiImageSet);
            }
            setGameInfo(updatedGameInfo);
            creatorDataSlice = await hanldeLastModifiedActivity();
          }

          if (currentSubTab === 1) {
            //show leaderboard gameIsShowLeaderboard
            updatedGameInfo = {
              ...gameInfo,
              gameData: { ...gameInfo.gameData, [modifiedField]: updatedValue },
            };
            setGameInfo(updatedGameInfo);
            creatorDataSlice = await hanldeLastModifiedActivity();
          }
          if (currentSubTab === 2) {
            //show Reflection            gameReflectionQuestion
            if (
              modifiedField !== 'gameReflectionQuestion' &&
              modifiedField !== 'gameIsShowReflectionScreen' &&
              modifiedField !== 'gameIsLearnerMandatoryQuestion'
            ) {
              updatedGameInfo = {
                ...gameInfo,
                reflectionQuestions: gameInfo?.reflectionQuestions.map(
                  (item: any) => {
                    if (item.refKey === modifiedField) {
                      return { ...item, refQuestion: updatedValue }; // Update the value property
                    }
                    return item;
                  },
                ),
              };
              setGameInfo(updatedGameInfo);
            } else if (
              modifiedField === 'gameReflectionQuestion' ||
              modifiedField === 'gameIsShowReflectionScreen'
            ) {
              setTimeout(() => {
                fetchCreatorDemoData();
              }, 1500);
            } else {
              updatedGameInfo = {
                ...gameInfo,
                gameData: {
                  ...gameInfo.gameData,
                  [modifiedField]: updatedValue,
                },
              };
              setGameInfo(updatedGameInfo);
            }
            creatorDataSlice = await hanldeLastModifiedActivity();
          }
          if (currentSubTab === 3) {
            if (modifiedField === 'gameIsShowTakeaway') {
              updatedGameInfo = {
                ...gameInfo,
                gameData: {
                  ...gameInfo.gameData,
                  [modifiedField]: updatedValue,
                },
              };
            } else {
              updatedGameInfo = {
                ...gameInfo,
                gameData: {
                  ...gameInfo.gameData,
                  [modifiedField]: updatedValue,
                },
              };
            }

            setGameInfo(updatedGameInfo);
            creatorDataSlice = await hanldeLastModifiedActivity();
          }
          if (currentSubTab === 4) {
            if (modifiedField === 'gameIsShowAdditionalWelcomeNote') {
              updatedGameInfo = {
                ...gameInfo,
                gameData: {
                  ...gameInfo?.gameData,
                  [modifiedField]: updatedValue,
                  gameAdditionalWelcomeNote: '',
                },
              };
              setGameInfo(updatedGameInfo);
            } else {
              //show welcome
              updatedGameInfo = {
                ...gameInfo,
                gameData: {
                  ...gameInfo?.gameData,
                  [modifiedField]: updatedValue,
                },
              };
              setGameInfo(updatedGameInfo);
            }
            creatorDataSlice = await hanldeLastModifiedActivity();
          }
          if (currentSubTab === 5) {
            //show Thank you
            updatedGameInfo = {
              ...gameInfo,
              gameData: {
                ...gameInfo?.gameData,
                [modifiedField]: updatedValue || '',
              },
            };
            setGameInfo(updatedGameInfo);
            creatorDataSlice = await hanldeLastModifiedActivity();
          }
        } else if (currentTab === 6) {
        /**Preference Screen */
          if (currentSubTab === 0) {
            if (modifiedField === 'gameIntroMusic') {
              updatedGameInfo = {
                ...gameInfo,
                gameData: {
                  ...gameInfo.gameData,
                  [modifiedField]: updatedValue?.gasId
                    ? updatedValue?.gasId
                    : '',
                  gameIntroMusicName: updatedValue?.gasAssetImage
                    ? updatedValue?.gasAssetImage
                    : '',
                },
              };
              setGameInfo(updatedGameInfo);
              creatorDataSlice = await hanldeLastModifiedActivity();
            } else {
              updatedGameInfo = {
                ...gameInfo,
                gameData: {
                  ...gameInfo.gameData,
                  [modifiedField]: updatedValue,
                },
              };
              setGameInfo(updatedGameInfo);
              creatorDataSlice = await hanldeLastModifiedActivity();
            }
          } else {
            await fetchCreatorDemoData(); // Wait for the async function to complete
            creatorDataSlice = await hanldeLastModifiedActivity();
          }
        }
        setProfile((prev: any) => ({ ...prev, language: gameLanguage }));
        return;
      } else {
        const {
          CompKeyCount,
          activeBlockSeq,
          currentQuest,
          currentSubTab,
          currentTab,
          gameId,
          isDispatched,
          isModified,
          modifiedField,
          onFocusValue,
          updatedValue,
          gameLanguage,
        } = previewStateData;
        if (currentTab === 3) {
          creatorDataSlice = await hanldeLastModifiedActivity();
          //navigate to welcome screen. it can fetch the latest skill by itself
        }
        if (currentTab === 4) {
          if (
            previewStateData.hasOwnProperty('action') &&
            previewStateData.action !== null
          ) {
            const { name, value } = previewStateData.action;
            setPromptType(previewStateData.action);
            creatorDataSlice = await hanldeLastModifiedActivity();
          } else {
            setPromptType(null);
            creatorDataSlice = await hanldeLastModifiedActivity();
            fetchCreatorDemoData(); // Wait for the async function to complete
          }
        } else {
          await fetchCreatorDemoData(); // Wait for the async function to complete
          creatorDataSlice = await hanldeLastModifiedActivity();
        }
        setProfile((prev: any) => ({ ...prev, language: gameLanguage }));
      }
    }
  };

  useEffect(() => {
    if (!reviewid && !id && previewid) {
      if (gameInfo || preLogDatasIni) {
        handleDataFetch();
      }
    }
  }, [previewStateData, isLoading]);

  useEffect(() => {
    if (isAuthFailed.status === true || contentReady === true) {
      setIsLoading(false);
    }
  }, [isAuthFailed, contentReady, isLoading]);

  const QuestDeleteMsDisplay = () => {
    return (
      <>
        <Box
          width={'100%'}
          h={'100vh'}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          bgImage={preloadedAssets.introBgImage}
          bgAttachment={'fixed'}
          bgSize={'cover'}
        >
          <Img src={preloadedAssets?.Replay} className="setting-pad" />
          <Box className={'replay-prompt-vertex'}>
            <Box
              w={'100%'}
              h={'100%'}
              display={'flex'}
              flexDirection={'column'}
              justifyContent={'space-between'}
            >
              <>
                <Box className="replay_game_text"> {FirstQuestDeleteMsg}</Box>
                <Box
                  display={'flex'}
                  justifyContent={'center'}
                  w={'100%'}
                  onClick={handleClick}
                >
                  <Button background={'transparent !important'}>
                    <Img
                      src={preloadedAssets?.OkayBtn}
                      className="replay_game_btn"
                    />
                  </Button>
                </Box>
              </>
            </Box>
          </Box>
        </Box>
      </>
    );
  };
  const handleClick = async () => {
    InitialScreenId.current = 10;
    setAllowQuestMsg(false);
    setFirstQuestDeleteMsg(null);
    dispatch(
      updatePreviewData({
        gameId: gameInfo.gameId,
        action: null,
        isModified: false,
      }),
    );
  };
  // if (reviewid) {
  //   return (
  //     <div
  //       style={{
  //         width: '100vw',
  //         height: '100vh',
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //       }}
  //     >
  //       <div>
  //         <h1 style={{ color: 'lightgray', fontSize: 'xxx-large' }}>
  //           Oops...!
  //         </h1>
  //         <h3 style={{ color: 'lightgray', fontSize: 'large' }}>
  //           Kindly please open in Desktop view
  //         </h3>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <>
      <Box background={'black'} h={'100vh'} width={'100vw'}>
        <MobileOrientationPrompt onRotate={() => {}} />
        {isLoading && <InitialLoader />}
        {AllowQuestMsg === true && <QuestDeleteMsDisplay />}
        {isAuthFailed.status === true && AllowQuestMsg === false && (
          <NoAuth
            isAuthFailed={isAuthFailed.status}
            status={isAuthFailed.authMsg}
            bgImage={preloadedAssets.introBgImage}
            isLoading={isLoading}
            reviewStatus={isAuthFailed.reviewStatus}
          />
        )}
        {contentReady === true &&
          gameInfo?.gameId &&
          AllowQuestMsg === false && (
            <ScoreContext.Provider value={{ profile, setProfile }}>
              <Box id="container">
                <Box>
                  <Box id="EntirePreview-wrapper">
                    <Box className="EntirePreview-content">
                      <Box id="container" className="Play-station">
                        <EntirePreview
                          currentScore={currentScore}
                          setCurrentScore={setCurrentScore}
                          gameInfo={gameInfo}
                          isReviewDemo={isReviewDemo}
                          preloadedAssets={preloadedAssets}
                          InitialScreenId={InitialScreenId.current}
                          fetchGameData={fetchGameData}
                          fetchPreviewLogsData={fetchPreviewLogsData}
                          previewLogsDataIni={previewLogsDataIni}
                          preLogDatasIni={preLogDatasIni}
                          initialStateUpdate={initialStateUpdate}
                          setInitialStateUpdate={setInitialStateUpdate}
                          creatorDataSlice={creatorDataSlice}
                          promptType={promptType}
                          setGameInfo={setGameInfo}
                          setIsAuthFailed={setIsAuthFailed}
                          isAuthFailed={isAuthFailed}
                          fetchCreatorDemoData={fetchCreatorDemoData}
                          isLoading={isLoading}
                          glbName={glbName}
                          selectedBackground={selectedBackground}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </ScoreContext.Provider>
          )}
      </Box>
    </>
  );
};
export default GamePreview;

function InitialLoader() {
  return (
    <>
      <Box className="Entire-Loader" style={{ zIndex: '99999999 !important' }}>
        <motion.div
          className="Entire-Loader-wrapper"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          style={{ zIndex: '99999999 !important', opacity: 1 }}
        >
          <Img
            src={LoadImg}
            className="load"
            style={{ zIndex: '99999999 !important',opacity: 1 }}
          />
        </motion.div>
      </Box>
    </>
  );
}

type CurrentTabCloseProps = {
  handleCloseTab: () => void;
  handleCancel: () => void;
};

function CurrentTabClose({
  handleCloseTab,
  handleCancel,
}: CurrentTabCloseProps) {
  return (
    <Modal isOpen={true} onClose={handleCancel}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Confirmation</ModalHeader>
        <ModalCloseButton />
        <ModalBody>Are you sure you want to close this tab?</ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleCloseTab}>
            OK
          </Button>
          <Button variant="ghost" onClick={handleCancel}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
